module.exports = __webpack_public_path__ + "img/img7.19f62698.svg";